import { PRIMARY_FILL_COLOR } from '../../../../theme/colors';

export const TRACKS_WRAPPER_STYLE = {
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  marginTop: 20,
  marginLeft: 24,
  marginRight: 48, // right margin + close button
  marginBottom: 20,
  position: 'relative'
};

export const TRACKS_WRAPPER_RESPONSIVE_STYLE = {
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  marginLeft: 20,
  marginRight: 40 // right margin + close button
};

export const TRACKS_WRAPPER_TV_STYLE = {
  flexDirection: 'column',
  margin: '40px',
  gap: '70px'
};

export const TRACK_DIALOG_CLOSE_LABEL_STYLE = {
  default: { top: 0, right: 0 },
  extraSmall: { top: 14, right: 'unset', left: 'unset', bottom: 'unset' },
  'small+medium': { top: 14, right: 32 },
  large: { top: 4, right: 12 }
};

export const TRACKLIST_STYLES = {
  sectionItems: {
    padding: '0 10px 15px 0',
    diplay: 'flex',
    flexDirection: 'row',
    margin: 0,
    fontSize: 18,
    fontFamily: 'Brown',
    fontWeight: 400,
    lineHeight: 1.5
  },
  section: {
    flex: 1
  },
  sectionTitle: {
    default: {
      fontFamily: 'Brown',
      fontSize: 20,
      height: 30,
      fontWeight: 700,
      marginBottom: 28,
      display: 'block',
      width: '100%',
      whiteSpace: 'nowrap',
      color: PRIMARY_FILL_COLOR
    },
    small: {
      marginBottom: 20
    },
    extraSmall: {
      marginBottom: 20
    }

  }
};

export const TRACKLIST_MODAL_BASIC_STYLE = {
  default: { width: 494, right: -6, bottom: 0, lineHeight: 'inherit' },
  medium: { width: 494, right: -6, bottom: -4 },
  'small+extraSmall': { width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', right: 0, top: 0, borderRadius: 0 },
  large: { width: 494, right: -6, top: 12 }
};
